import React, { useMemo, useState } from 'react';
import AudioMatcher from './AudioMatcher';
import backendGameConfig from './generated/backendGameConfig.json';
import { buildGameOptions } from './audioMatcherUtils';
import './App.css';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.mimansaplay.mimansaapp';

export default function App() {
  const gameOptions = useMemo(() => buildGameOptions(backendGameConfig), []);
  const defaultGameTag = useMemo(
    () => gameOptions.find(option => option.id === 'BUZZ')?.id || gameOptions[0]?.id || '',
    [gameOptions]
  );

  const [selectedGameTag, setSelectedGameTag] = useState(defaultGameTag);

  return (
    <div className="app-container">
      <div className="card">
        <h1>Phoneme Matcher</h1>
        <p className="description">
          A real-time speech recognizer tool that listens to the words you speak, decodes them into
          phonemes, and compares them to the selected game target.
        </p>
        <p className="description subtle">
          Expected phonemes are now taken directly from the backend game tag configuration.
        </p>

        <div className="input-group">
          <label htmlFor="game-tag-select">Game Tag</label>
          <select
            id="game-tag-select"
            value={selectedGameTag}
            onChange={event => setSelectedGameTag(event.target.value)}
          >
            {gameOptions.map(option => (
              <option key={option.id} value={option.id}>
                {option.id}
              </option>
            ))}
          </select>
        </div>

        <AudioMatcher selectedGameTag={selectedGameTag} />

        <footer className="footer">
          <div>Made with ❤️ by MimansaPlay</div>
          <p className="footer-note">
            Browser speech detection may vary. For best results, play our mobile-optimized games on{' '}
            <a href={PLAY_STORE_URL} target="_blank" rel="noreferrer">
              the Play Store
            </a>.
          </p>
        </footer>
      </div>
    </div>
  );
}
